import type { Conveyancer } from '../enums';

export const CONVEYANCER_LABELS: Record<Conveyancer, string> = {
    unity: 'Unity',
    goveyance: 'GoVeyance',
};

export function getConveyancerLabel(conveyancer: Conveyancer): string {
    return CONVEYANCER_LABELS[conveyancer];
}

export function formatConveyancers(conveyancers: Conveyancer[]): string {
    return conveyancers.map(getConveyancerLabel).join(', ');
}
